import script from "./AdminFulfillment.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFulfillment.vue?vue&type=script&setup=true&lang=js"

import "./AdminFulfillment.vue?vue&type=style&index=0&id=319c1ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319c1ba6"]])

export default __exports__